import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Button from '../../components/Button';
import { _formatNumbers, urls } from '../../common';
import Label from '../../components/form/Label';
import Input from '../../components/form/Input';
import { myToast } from '../../common/Toast';
import { faBiohazard, faPoundSign, faX } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useParams } from 'react-router-dom';


function HomePage({ type }: { type?: string }) {

    const urlParams = new URLSearchParams(window.location.search);
    const price = urlParams.get("price");
    const ref = urlParams.get("ref");


    const [reference, setReference] = useState(ref || '');
    const [amount, setAmount] = useState<number | undefined>(price ? parseFloat(price as string) : undefined);
    const [disabled, setDisabled] = useState(false);

    const submitPayment = () => {
        if (!amount || amount <= 0) {
            myToast({ title: 'Amount Required?', icon: faPoundSign, colour: 'red' })
            return;
        }
        setDisabled(true);
        axios.post(`${urls.api}super-payments/create-payment`, { reference, amount: amount * 100 })
            .then(({ data }) => {
                setDisabled(false);
                window.location.assign(data.url)
            })
            .catch((error) => {
                setDisabled(false);
                myToast({ title: 'Error Creating Payment?', icon: faBiohazard, colour: 'red' })
            })
    }

    return (
        <main>
            <div className="mx-auto mt-16 max-w-7xl px-6 sm:mt-32 lg:px-8 space-y-6">
                <div className="mx-auto max-w-4xl text-center">
                    <p className="mt-2 text-balance text-5xl font-semibold tracking-tight text-gray-300 sm:text-6xl">
                        Make your payment...
                    </p>
                </div>

                {type === 'cancelled' &&
                    <div className="rounded-md border border-red-300 bg-red-100 p-4 space-y-4 relative">
                        <Link to="../" className="!text-slate-900 absolute right-0 top-0 p-2"><FontAwesomeIcon icon={faX} fixedWidth /></Link>
                        <p className="text-red-600 text-center text-balance text-3xl font-semibold tracking-tight">Payment Cancelled</p>
                        <p className="text-center">Your payment has been cancelled, please try again.</p>
                    </div>
                }

                {type === 'success' &&
                    <div className="rounded-md border border-green-300 bg-green-100 p-4 space-y-4 relative">
                        <Link to="../" className="!text-slate-900 absolute right-0 top-0 p-2"><FontAwesomeIcon icon={faX} fixedWidth /></Link>
                        <p className="text-green-600 text-center text-balance text-3xl font-semibold tracking-tight">Thank you for your payment</p>
                    </div>
                }

                {type === 'failed' &&
                    <div className="rounded-md border border-red-300 bg-red-100 p-4 space-y-4 relative">
                        <Link to="../" className="!text-slate-900 absolute right-0 top-0 p-2"><FontAwesomeIcon icon={faX} fixedWidth /></Link>
                        <p className="text-red-600 text-center text-balance text-3xl font-semibold tracking-tight">Sorry, your payment has failed?  </p>
                        <p className="text-center">Please try again.</p>
                    </div>
                }

                <div className="rounded-md border border-gray-300 bg-white p-4 space-y-4">

                    <p>Please fill in the following, if you are paying a deposit or invoice please include your name and reference number</p>
                    <div className="">
                        <Label required>Reference:</Label>
                        <Input
                            value={reference}
                            onFocus={(e) => e.target.select()}
                            type="text" placeholder="Monthly Pass" onChange={(e) => setReference(e.target.value)} />
                    </div>

                    <div className="">
                        <Label required>Amount:</Label>
                        <Input
                            onFocus={(e) => e.target.select()}
                            // value={amount?.toFixed(2)}
                            min="0" type="number" step='0.01' placeholder="40.00" required onChange={(e) => setAmount(parseFloat(e.target.value))} />
                    </div>


                    <Button
                        className="w-full " color="kilnworx-green"
                        onClick={() => { submitPayment() }}
                        disabled={disabled}
                    >Pay using Super Payments</Button>

                </div>
            </div>
        </main>
    )
}

export default HomePage;